// extracted by mini-css-extract-plugin
module.exports = {"row":"ActiveIncidentIcon_row__ZxKHP","incidentCount":"ActiveIncidentIcon_incidentCount__2vGVS"};